import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EAmenityType } from '../../../packages/api-models/common/json_query';

export const selectAmenity = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('amenity')(jsonQuery) as EAmenityType[] | null,
);
